// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"b57eae1f","703":"f3b19e36","787":"ad326f90"}[chunkId] + ".chunk.js";
};